import { render } from "./Tal_leaveTheAlim.vue?vue&type=template&id=a939266a&scoped=true"
import script from "./Tal_leaveTheAlim.vue?vue&type=script&lang=js"
export * from "./Tal_leaveTheAlim.vue?vue&type=script&lang=js"

import "./Tal_leaveTheAlim.vue?vue&type=style&index=0&id=a939266a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a939266a"]])

export default __exports__